/**
 * Returns the localized biography for an artist object based on the current locale.
 * Supports: 'pt-BR', 'en', 'es', 'fr' (with fallback to English or Portuguese/default bio).
 */
export function getLocalizedBio(artist, currentLocale = 'pt-BR') {
  if (!artist) return '';

  const translations = artist.bioTranslations || artist.bio_translations;
  if (!translations || typeof translations !== 'object' || Object.keys(translations).length === 0) {
    return artist.bio || '';
  }

  const lang = currentLocale || 'pt-BR';
  if (translations[lang]) return translations[lang];

  // Map variations (e.g. 'pt' -> 'pt-BR', 'en-US' -> 'en', 'es-ES' -> 'es', 'fr-FR' -> 'fr')
  const shortLang = lang.split('-')[0].toLowerCase();
  if (shortLang === 'pt' && translations['pt-BR']) return translations['pt-BR'];
  if (translations[shortLang]) return translations[shortLang];

  for (const key of Object.keys(translations)) {
    if (key.toLowerCase().startsWith(shortLang)) {
      return translations[key];
    }
  }

  return translations['en'] || translations['pt-BR'] || artist.bio || '';
}
